import { Metadata } from "@/types/metadata"
import { useTranslation } from "../useTranslation"

type State = {
    data: Array<Metadata>;
}

const paísesPermitidos = [1, 65, 150, 166, 177]

const useEventCountries = (): State => {
    const { t, lang } = useTranslation()

    return {
        data: paísesPermitidos.map(país => ({
            id: país,
            value: t(`eventCountries.${país}`)
        })).sort((a, b) => a.value.localeCompare(b.value, lang))
    }
}

export default useEventCountries